
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/templates/[vertical]",
      function () {
        return require("private-next-pages/templates/[vertical].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/templates/[vertical]"])
      });
    }
  